import { FlexibleSetDiscountType } from '../../flexSets/flexSetTile/flex-set-tile';
import {
    IBrick,
    IFlexibleSet,
    IFlexibleSetPrice,
} from '../../flexSets/flexSetTile/flex-set-tile.d';
import {
    ISearchBrickItem, 
    ISearchFlexibleSet, 
    ISearchFlexibleSetDiscountType, 
    ISearchFlexibleSetPrice 
} from '../searchresultpage.d';

export function mapToFlexibleSetTiles(
    flexSets: ISearchFlexibleSet[]
): IFlexibleSet[] {
    return flexSets.map((set, i) => {
        return {
            set: {
                fsCode: set.fsCode,
                flexibleSetImageFullPath: set.flexibleSetImage,
                salesDesignation: set.salesDesignation,
                isAvailable: true, // placeholder value
                navigationKey: null,
                fspLink: set.url,
                sortedBricks: mapToFlexibleSetBricks(flexSets[i].sortedBricks),
            },
            price: mapToFlexibleSetPrice(set.price),
            tileId: set.fsCode,
            pageNo: 1, //For this use case pageNo should not needed
            elementRef: null, // For this use case there will be no progress bar
        };
    });
}

function mapToFlexibleSetPrice(price: ISearchFlexibleSetPrice): IFlexibleSetPrice {
    return {
        originalPrice: price.originalPrice,
        price: price.price,
        discountType: mapToFlexibleSetDiscountType(price.discountType),
        discountPercentage: price.discountPercentage
    }
}

function mapToFlexibleSetDiscountType(discountType: ISearchFlexibleSetDiscountType) {
    if (discountType === ISearchFlexibleSetDiscountType.DynamicPrice)
        return FlexibleSetDiscountType.DynamicPrice;
    if (discountType === ISearchFlexibleSetDiscountType.FixedPrice)
        return FlexibleSetDiscountType.FixedPrice;
    if (discountType === ISearchFlexibleSetDiscountType.FreeItem)
        return FlexibleSetDiscountType.FreeItem;
}

function mapToFlexibleSetBricks(flexBricks: ISearchBrickItem[]): IBrick[] {
    return flexBricks.map((brick) => {
        return {
            brickNo: brick.brickNo,
            positionNo: 0, // placeholder value
            isFree: brick.isFree,
            items: [
                {
                    positionNo: 0, // placeholder value
                    quantity: brick.quantity,
                    imageFullPath: brick.articleImage,
                    altTagForImage: brick.articleName,
                    brickItemNo: brick.brickItemNo,
                    mainBrickItem: true, // PCS only provides the mainBrickItem
                    isAvailable: true, // placeholder value
                },
            ],
        };
    });
}
